<div id="progressBar" *ngIf="progress > 0">
  <div class="container">
    <p class="text-dark font-bold mb-2">{{progressTitle}}</p>
    <div class="progress">
      <div class="progress-bar" [style.width.%]="progress" role="progressbar" [aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</div>
